import { SVGProps } from "react";
import { motion } from "framer-motion";

const Circle = (props: SVGProps<SVGSVGElement> & { animate?: boolean }) => (
  <motion.svg
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8.75"
      cy="8.75"
      r="8"
      stroke={props.fill || "#9B9B9B"}
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </motion.svg>
);
export default Circle;
